import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    business_userToken: '',
    business_openId: '',
    resources: <any>{},
  },
  getters: {},
  mutations: {
    //登录信息
    setBusinessUserToken(state, n) {
      state.business_userToken = n;
    },
    setBusinessOpenId(state, n) {
      state.business_openId = n;
    },
    //静态资源数据
    setResources(state, n) {
      state.resources = n;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      //storage: window.sessionStorage, // 注意
    }),
  ],
});
